import GET from "./GET";
import inPreview from "./inPreview";
const inExtensionPreview = (inPreview && GET("extensionPreview")) || false;
export default inExtensionPreview;
